export const MessageMap = {

};
